import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { viewChangeKeyPositionCertificateCoOrdinatorData } from "./data/ViewChangeKeyPositionCertificateCoOrdinator.data";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { ViewChangeKeyPositionCertificateCoOrdinatorConfig } from "./component/ViewChangeKeyPositionCertificateCoordinatorDataConfig";
import { useGetAllKeyPositionApprovalRequestListMutation, useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import { setAllDropDownField } from "../ViewChangeKeyPosition/data/Utils/setFieldParameter";
import { useNavigate } from "react-router-dom";
import { encryptAESID } from "../../utils/Encryption";

const ViewChangeKeyPositionCertificateCoOrdinator = () => {
  const viewChangeKeyPositionCertificateCoOrdinatorRef = useRef();
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState();
  const [totalRecord, setTotalRecord] = useState()
  const navigate = useNavigate();
  const [viewChangeKeyPositionCertificateCoOrdinatorForm, setViewChangeKeyPositionCertificateCoOrdinatorForm] = useState(viewChangeKeyPositionCertificateCoOrdinatorData);


  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    searchText: "",
    filterByStatus: "",
    dateFrom: "",
    dateTo: "",
    isCertificationCordinator: true,
  });
  const [getAllKeyPositionApprovalRequestList, { data: getAllKeyPositionList, isSuccess, isLoading, }] = useGetAllKeyPositionApprovalRequestListMutation();
  const [signUpDropDownsForCorporateMembers, { data: corporateMemberDropDownsData, isLoading: corporateDropDownsLoading, isFetching: signUpDropDownsFetching }] = useLazyGetSignUpDropDownsForCorporateMembersQuery();

  useEffect(() => {
    signUpDropDownsForCorporateMembers();
    getAllKeyPositionApprovalRequestList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!corporateDropDownsLoading && corporateMemberDropDownsData) {
      setAllDropDownField(corporateMemberDropDownsData);
    }
  }, [corporateDropDownsLoading, corporateMemberDropDownsData]);

  useEffect(() => {
    if (!isLoading && isSuccess && getAllKeyPositionList) {
      setPaginationRequest(prev => ({ ...prev, totalCount: getAllKeyPositionList.totalCount }));
      setDataSource(getAllKeyPositionList?.itemList);
      setTotalRecord(getAllKeyPositionList?.totalCount)
    }
  }, [isLoading, isSuccess, getAllKeyPositionList]);

  const handleSearch = () => {
    if (!viewChangeKeyPositionCertificateCoOrdinatorRef.current) {
      return;
    }
    const taskListFormData = viewChangeKeyPositionCertificateCoOrdinatorRef?.current?.getFormData();
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 20,
      endPage: 100,
      searchText: taskListFormData?.companyName || "",
      FilterByStatus: taskListFormData?.status?.label || taskListFormData?.status,
      dateFrom: taskListFormData?.fromDate || null,
      dateTo: taskListFormData?.toDate || null,
      isCertificationCordinator: true,
    };
    setPaginationRequest(updatedPaginationRequest);
    getAllKeyPositionApprovalRequestList(updatedPaginationRequest);
  };

  const handleProcessClick = (data) => {
    navigate(`/keyPositionRequest/${encryptAESID(data?.keyChangeRequestId)}/${encryptAESID(data?.upgradeChangeRequestId)}`);
  }

  const actionHandler = {
    VIEW: handleProcessClick,
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllKeyPositionApprovalRequestList(updatedPaginationRequest);
  };

  const handleClearClick = () => {
    const updatedFormData = { ...viewChangeKeyPositionCertificateCoOrdinatorForm };
    updatedFormData.initialState = {
      companyName: null,
      fromDate: null,
      toDate: null,
      status: null,
    };

    const request = {
      ...paginationRequest,
      pageNo: 1,
      searchText: "",
      filterByStatus: "",
      dateFrom: "",
      dateTo: "",
    };

    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getAllKeyPositionApprovalRequestList(request);
    setViewChangeKeyPositionCertificateCoOrdinatorForm(updatedFormData);
  };



  return (
    <div className="view-change-key-position">
      <div className="filter-section row">
        <div className="row col-12 col-md-12 col-lg-8 col-xl-8 ">
          {corporateMemberDropDownsData &&
            <FormCreator
              ref={viewChangeKeyPositionCertificateCoOrdinatorRef}
              {...viewChangeKeyPositionCertificateCoOrdinatorForm}
            />
          }
        </div>
        <div className="col-4 right-side-btn mt-4">
          <Buttons
            buttonText="Search"
            buttonTypeClassName="success-btn"
            onClick={handleSearch}
          />
          <Buttons
            buttonText="Clear"
            buttonTypeClassName="btn btn-secondary"
            onClick={handleClearClick}
          />
        </div>
      </div>
      <div className="result-section">
        <div>
          <h4>{totalRecord} Records</h4>
        </div>
        <MolGrid
          ref={molGridRef}
          configuration={ViewChangeKeyPositionCertificateCoOrdinatorConfig}
          allowPagination={true}
          dataSource={dataSource}
          isLoading={isLoading}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
          onActionChange={actionHandler}
        />
      </div>
    </div>
  );
};

export default ViewChangeKeyPositionCertificateCoOrdinator;
